import { render } from "./RecipientBadge.vue?vue&type=template&id=52005bb1"
import script from "./RecipientBadge.vue?vue&type=script&lang=js"
export * from "./RecipientBadge.vue?vue&type=script&lang=js"
script.render = render

export default script